import { useFormContext, Controller } from 'react-hook-form';
import {
  SelectProps,
  FormControl,
  FormHelperText,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import Label from '../label/Label';

interface RHFMultiSelectProps extends Omit<SelectProps, 'label' | 'variant'> {
  name: string;
  label?: string;
  placeholder?: string;
  helperText?: React.ReactNode;
  wrap?: boolean;
  control?: any;
  options: any[];
}

export default function RHFCardSelect({
  name,
  label,
  options,
  placeholder,
  helperText,
  sx,
  control,
  wrap,
  id,
  ...other
}: RHFMultiSelectProps) {
  const { control: controContext } = useFormContext();

  return (
    <Controller
      name={name}
      control={control ?? controContext}
      render={({ field, fieldState: { error } }) => (
        <FormControl sx={sx} id={id}>
          {label && <Label id={name}> {label} </Label>}

          <Stack
            direction="row"
            alignItems="center"
            padding={2}
            justifyContent="center"
            sx={{
              overflowX: 'scroll',
              flexWrap: {
                xs: wrap ? 'wrap' : 'nowrap',
                md: 'wrap',
              },
            }}
            rowGap={1.5}
            columnGap={4}
          >
            {options?.map?.((item: any, index: number) => (
              <Card
                key={`${item.id}-${item.name}-${index}`}
                sx={{
                  maxWidth: {
                    md: 155,
                    xs: 140,
                  },
                  width: {
                    md: 155,
                    xs: 135,
                  },
                  minHeight: {
                    md: 100,
                    xs: 130,
                  },
                  overflow: 'initial',
                  display: 'flex',
                  cursor: 'pointer',
                  justifyContent: 'center',
                  alignItems: 'center',
                  border:
                    field.value?.value === item.id && field.value.label === item.name
                      ? 'solid 1px red'
                      : 'transparent',
                }}
                onClick={() => field.onChange({ value: item.id, label: item.name })}
              >
                <CardContent sx={{ width: '100%' }}>
                  <Typography
                    textAlign="center"
                    sx={{ fontWeight: 'bold', fontSize: 13, overflowWrap: 'break-word' }}
                  >
                    {item.name}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Stack>

          {(!!error || helperText) && (
            <FormHelperText error={!!error}>{error ? error?.message : helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
